<template>
    <v-dialog fullscreen light persistent v-model="isLoading"  style="padding-bottom:50px;opacity: 0.5;  ">
      <v-layout align-center  column justify-center style="background-color: black; opacity: 0.5; height:800px" >
            <v-progress-circular
            :size="150"
            :width="7"
            color="blue"
            indeterminate
          ></v-progress-circular>
      </v-layout>
    </v-dialog>

  <!--div>
    <div class="loading-mask showLoading" v-if="isLoading">
      <div class="spinner sp-purple"></div>
    </div>
    <div class="in showLoading" :class="{'loading-mask-backdrop-trasparent':trasparent,'loading-mask-backdrop':!trasparent}" v-if="isLoading"></div>
  </div-->
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    }

  },
  watch: {
    isLoading (newVal) {
     // console.log('>>>> chiamato isLoading')
      if (newVal) {
        setTimeout(() => {
          this.$root.$emit('isLoading', {isLoading: false})
        }, 60000) // un minuto come timeout delle chiamate REST
      }
    }
  }
}
</script>

<style scoped>

</style>
